export default {
  selected: 'Selected',
  deselect_all_selected_options: 'Deselect all selected options',
  expanded: 'Expanded',
  collect: 'Collect',
  no_options_available: 'No options available',
  required: 'required',
  input_clear_aria_label: 'Clear input',
  input_show_hide_password_aria_label: 'Show or hide password',
  input_increment_aria_label: 'Increment value',
  input_decrement_aria_label: 'Decrement value',
  english: 'English',
  chinese: 'Chinese',
  portuguese: 'Portuguese',
  spanish: 'Spanish',
  dutch: 'Dutch',
  french: 'French',
  german: 'German',
  russian: 'Russian',
  ukrainian: 'Ukrainian',
  korean: 'Korean',
  italian: 'Italian',
  czech: 'Czech',
  access_your_account: 'Access your account',
  use_your_company_credentials_to_get_started:
    'Use your company credentials to get started',
  this_link_has_expired: 'This link has expired',
  login: 'Login',
  sample_no_production_date_message:
    "It's mandatory to select a production date.",
  free_comment: 'Free comment',
  save_comments: 'Save & Close',
  round_list_rounds: 'Rounds',
  round_edit_round: 'Edit Round',
  round_new_round: 'New Round',
  round_remove_round: 'Are you sure you want to delete the round',
  round_schedule: 'Schedule',
  round_tasters_unselect_all: 'Unselect all Tasters',
  round_tasters_select_all: 'Select all Tasters',
  round_close: 'Close Round',
  round_close_message: 'Are you sure you want to finish the Round',
  round_create_site_message:
    'You are creating a round that is not from your site!',
  round_closed_message: "Closed rounds can't be edited",
  round_status_created: 'Created',
  round_status_samples: 'Samples',
  round_status_scheduled: 'Scheduled',
  round_status_tasters: 'Tasters',
  round_status_in_progress: 'In Progress',
  round_status_finished: 'Finished',
  round_status_closed: 'Closed',
  round_schedule_start_finish_date:
    'The Start Date cannot be greater than the Finish Date!',
  round_schedule_finish_date_no_start_date:
    'You have to select a Start date first!',
  round_disabled_discussion_tooltip:
    "You can't go to a Discussion of an unfinished round",
  round_up_down_maintenance_tooltip:
    'This feature is under maintenance and is temporarily unavailable',
  round_delete_other_users_rounds:
    "You don't have the permission to delete a round that wasn't created by you",
  round_randomize_samples_order_button: 'Shuffle',
  round_block_results_tooltip:
    'Lock the results of this round from being downloaded in the reports screen. If the button is disabled, you do not have the privilege to lock the results of rounds from this location',
  round_block_results_confirm:
    'Are you sure you want block/unblock the results of the round ',
  round_block_results_no_privilege:
    "You don't have the privilege to block/unblock round's results from this location.",
  sample_list_samples: 'Samples',
  sample_edit_sample: 'Edit Sample',
  sample_new_sample: 'New Sample',
  sample_remove_sample: 'Remove Sample',
  sample_upload_document: 'Upload Documents',
  sample_download_documents: 'Sample Documents',
  sample_tasted_dates: 'Taste Date',
  sample_upload_message: 'To upload multiple documents, add them to a ',
  sample_not_for_kpi: 'Not for KPI',
  sample_package: 'Package',
  sample_volume: 'Volume',
  sample_production_date: 'Production Date',
  sample_expire_date: 'Expiration Date',
  sample_trial_identifier: 'Trial Identifier',
  sample_project_name: 'Project Name',
  sample_linked: 'Linked to a Round',
  sample_expire_bigger_than_production:
    'The Production Date cannot be greater than the Expire Date!',
  sample_no_site_message:
    "It's mandatory to select a Zone, Country and a Site to create a sample.",
  sample_no_brand_message: "It's mandatory to select a Brand.",
  sample_duplicated_kpi_message:
    'There is already a KPI for the month, brand and site you selected and you will not be able to save',
  sample_duplicated_kpi_message_quarter:
    'There is already a KPI for the quarter, brand and site you selected and you will not be able to save',
  sample_duplicated_project_message:
    'There is already a sample with this Project Name and Trial Identifier for this Site and Brand, and you will not be able to save',
  sample_project_no_name_or_trial:
    'Project Name and Trial Identifier are mandatory when creating a sample of Project type',
  sample_production_to_project_confirm_message:
    'You are changing the type of this sample from PRODUCTION to PROJECT. Do you wish to continue?',
  sample_project_to_production_confirm_message:
    'You are changing the type of this sample from PROJECT to PRODUCTION. Do you wish to continue?',
  sample_no_volume_message:
    'Package and Volume are mandatory when creating/editing a sample.',
  sample_id_code_message: 'Please include the complete batch number',
  sample_show_all_samples_hint:
    'Showing samples created up until six months from today. Check this box if you want to see older samples as well',
  sample_show_all_samples_label: 'Show All Samples',
  package_duplicate: 'There is a package with this name already',
  common_production: 'Production',
  common_project: 'Project',
  group_list_groups: 'Groups',
  group_edit_group: 'Edit Group',
  group_new_group: 'New Group',
  group_remove_group: 'Remove Group',
  group_close_modal: 'Close',
  group_duplicated_user: 'This user has already been added to this group!',
  group_no_name_message: "It's necessary to enter a group name",
  group_no_zone_message: "It's necessary to select a Zone",
  group_no_users_message: "It's necessary to select at least one taster",
  family_list_families: 'Styles',
  family_edit_family: 'Edit Style',
  family_new_family: 'New Style',
  family_remove_family: 'Remove Style',
  families_page_description:
    'Manage all styles and their configurations in one place.',
  family_new_page_description:
    'Fill in style information and complete creation.',
  family_edit_page_description: 'Edit style information.',
  family_save_success: 'Style successfully created!',
  family_update_success: 'Style successfully updated!',
  family_save_failed: 'Style failed to save.',
  family_save_success_desc: 'Check it out in the styles below.',
  family_update_success_desc: 'Check it out in the styles below.',
  family_save_failed_desc: 'Please try again in a moment.',
  the_name_is_duplicated: 'The name is duplicated.',
  common_style_name: 'Style Name',
  common_warning: 'Warning',
  cancel_new_family_title: 'Cancel new style?',
  cancel_edit_family_title: 'Cancel edit style?',
  cancel_new_family_confirm: 'Cancel new style',
  cancel_edit_family_confirm: 'Cancel edit style',
  family_remove_success: 'Style removed successfully',
  family_remove_failed: 'Failed to remove style',
  family_delete_title: 'Delete style?',
  family_delete_description:
    '{{name}} style will be permanently removed. Are you sure you want to continue?',
  family_delete_success: 'Style successfully deleted!',
  family_delete_success_desc: 'The style has been removed.',
  family_delete_failed: 'Style failed to delete.',
  family_delete_failed_desc: 'Please try again in a moment.',
  family_has_no_english_name:
    "Attention: it's mandatory to have the Style name in English",
  brand_list_brands: 'Brands',
  brand_edit_brand: 'Edit Brand',
  brand_new_brand: 'New Brand',
  brand_remove_brand: 'Remove Brand',
  brand_profile_picture: 'Upload Beer Profile Picture',
  brand_upload_brand_logo: 'Upload Brand Logo',
  brand_duplicate: 'Warning: There is a beer with this name',
  brand_has_no_english_name:
    'You must have at least one brand name and a brand profile match with it.',
  brand_upload_help_message: 'PNG and JPG files only',
  brand_has_no_product_type: 'You must select a Product Type',
  package_list_packages: 'Packages',
  package_edit_package: 'Edit Package',
  package_new_package: 'New Package',
  package_remove_package: 'Delete',
  packages_page_description:
    'Manage all package types and their configurations in one place.',
  packages_edit_page_description:
    'Edit package information and complete the update.',
  package_successfully_created: 'Package successfully created!',
  package_successfully_created_desc: 'Check it out in the packages below.',
  package_successfully_updated: 'Package successfully updated!',
  package_successfully_updated_desc: 'Check it out in the packages below.',
  packages_new_page_description:
    'Fill in package information and complete creation.',
  package_name: 'Package Name',
  content_already_exists: 'Content already exists.',
  enter_language: 'Enter {{language}}',
  language_english: 'English',
  language_chinese: 'Chinese',
  language_portuguese: 'Portuguese',
  language_spanish: 'Spanish',
  language_dutch: 'Dutch',
  language_french: 'French',
  language_german: 'German',
  language_russian: 'Russian',
  language_ukrainian: 'Ukrainian',
  language_korean: 'Korean',
  language_italian: 'Italian',
  package_has_no_english_name:
    "Attention: it's mandatory to have the Package name in English",
  package_volumes: 'Volumes',
  package_new_volume: 'New volume',
  package_remove_volume: 'Remove Volume',
  degree_list_degrees: 'Intensities',
  degree_edit_degree: 'Edit Intensity',
  degree_new_degree: 'New Intensity',
  degree_remove_degree: 'Remove Intensity',
  category_list_categories: 'Categories',
  category_edit_category: 'Edit Flavor Category',
  category_new_category: 'New Flavor Category',
  category_remove_category: 'Remove Flavor Category',
  comment_list_comments: 'Attributes',
  comments_page_description:
    'Manage all attributes and their configurations in one place.',
  comments_new_page_description:
    'Fill in flavor attribute information and complete creation.',
  comments_edit_page_description:
    'Edit flavor attribute information and complete the update.',
  comment_attribute_name: 'Flavor Attribute Name',
  comment_select_category: 'Select flavor category',
  comment_edit_comment: 'Edit Flavor Attribute',
  comment_new_comment: 'New Flavor Attribute',
  comment_remove_comment: 'Remove Flavor Attribute',
  comment_cancel_new_title: 'Cancel new flavor attribute?',
  comment_cancel_edit_title: 'Cancel edit flavor attribute?',
  comment_cancel_new_confirm: 'Cancel new flavor attribute',
  comment_cancel_edit_confirm: 'Cancel edit flavor attribute',
  comment_successfully_created: 'Flavor attribute successfully created!',
  comment_successfully_created_desc: 'Check it out in the attribute below.',
  comment_successfully_updated: 'Flavor attribute successfully updated!',
  comment_successfully_updated_desc: 'Check it out in the attribute below.',
  comment_create_failed: 'Flavor attribute failed to create.',
  comment_update_failed: 'Flavor attribute failed to update.',
  comment_failed_desc: 'Please try again in a moment.',
  comment_delete_title: 'Delete attribute?',
  comment_delete_description:
    '{{name}} attribute will be permanently removed. Are you sure you want to continue?',
  comment_delete_success: 'Attribute successfully deleted!',
  comment_delete_success_desc: 'Check it out in the Attribute below.',
  comment_delete_failed: 'Attribute failed to delete.',
  comment_delete_failed_desc: 'Please try again in a moment.',
  user_list_users: 'Users',
  user_edit_user: 'Edit User',
  user_new_user: 'New ABI Contractor',
  user_export_users: 'Export Users',
  user_list_profiles: 'Profiles',
  user_profile_name: 'Profile Name',
  user_profile_select: 'Select a Profile',
  user_profile_remove: 'Remove Profile',
  user_profile_save: 'Save Profile',
  user_remove_user: 'Remove User',
  user_use_terms: 'Accepted Terms Of Use',
  report_list_report: 'Reports',
  report_list_report_description: 'Export reports of various types.',
  report_tab_tasting: 'Tasting',
  report_tab_kpi: 'KPI',
  report_tab_evaluation: 'Evaluation',
  report_tab_site: 'Site',
  report_tab_brand: 'Brand',
  report_tab_physchem: 'Physchem',
  report_tab_global: 'Global',
  report_start_date: 'Start Date',
  report_end_date: 'End Date',
  common_privileges: 'Privileges',
  common_abi_name: 'ABI Name',
  common_id: 'ID',
  common_ranked: 'Ranked',
  common_week: 'Week',
  common_weeks: 'Weeks',
  common_days: 'Days',
  common_category: 'Flavor Category',
  common_category_sample: 'Category',
  common_degree: 'Intensity',
  common_comment: 'Flavor Attribute',
  common_status: 'Status',
  common_zone: 'Zone',
  common_bu: 'BU',
  common_country: 'Country',
  common_site: 'Site',
  common_start_date: 'Start Date',
  common_finish_date: 'Finish Date',
  common_round_type: 'Taste Type',
  common_type: 'Type',
  common_round: 'Round',
  common_round_id: 'Round ID',
  common_tasters: 'Tasters',
  common_taster: 'Taster',
  common_sample_performance: 'Sample Performance',
  common_taste: 'Taste',
  common_key_taster: 'Key Taster',
  common_sample: 'Sample',
  common_samples: 'Samples',
  common_sample_type: 'Sample Type',
  common_family: 'Style',
  common_brand: 'Brand',
  common_product_type: 'Product Type',
  common_temperature: 'Storage Condition',
  common_storage_times: 'Storage Time',
  common_sku: 'SKU',
  common_batch: 'ID Code',
  common_kpi_month: 'KPI Month',
  common_logo: 'Logo',
  common_name: 'Name',
  common_notes: 'Notes',
  common_email: 'E-mail',
  common_language: 'Language',
  common_terms_of_use: 'Terms of Use',
  common_new: 'New',
  common_profile: 'Profile',
  common_filter: 'Filter Users',
  common_download: 'Download',
  download: 'Download',
  common_save: 'Save',
  common_cancel: 'Cancel',
  unsaved_changes_warning:
    'You have unsaved changes. Are you sure you want to leave?',
  common_go_back: 'Go back',
  cancel_create_action_title: 'Cancel creating action?',
  cancel_edit_action_title: 'Cancel editing action?',
  cancel_create_action_confirm: 'Cancel creating action',
  cancel_edit_action_confirm: 'Cancel editing action',
  cancel_new_kpi_brand_title: 'Cancel new KPI brand?',
  cancel_edit_kpi_brand_title: 'Cancel KPI brand edit?',
  unsaved_changes_description:
    'You have entered content in the form. Canceling will discard all unsaved input. Are you sure you want to continue?',
  unsaved_changes_edit_description:
    'You have changed content in the form. Canceling will discard all unsaved input. Are you sure you want to continue?',
  cancel_new_kpi_brand_confirm: 'Cancel new KPI brand',
  cancel_edit_kpi_brand_confirm: 'Cancel KPI brand edit',
  cancel_add_taster_title: 'Cancel add taster?',
  cancel_add_taster_description:
    'You have already selected tasters. Canceling will discard your selection. Are you sure you want to continue?',
  cancel_add_taster_confirm: 'Cancel add taster',
  cancel_enter_concentration_title: 'Cancel enter concentration?',
  cancel_enter_concentration_description:
    'You have entered a concentration value. Canceling will discard the unsaved input. Are you sure you want to continue?',
  cancel_enter_concentration_confirm: 'Cancel enter concentration',
  cancel_new_package_title: 'Cancel new package?',
  cancel_edit_package_title: 'Cancel package edit?',
  cancel_new_package_confirm: 'Cancel new package',
  cancel_edit_package_confirm: 'Cancel package edit',
  common_search_users: 'Search Users',
  common_search_group: 'Search Group',
  common_search_taster: 'Search Taster',
  common_no_data: 'No data to show',
  common_edit: 'Edit',
  no_results_found_for_applied_filters:
    'No results found for the applied filters',
  common_loading: 'Loading...',
  common_search: 'Search...',
  type_more_characters: 'Type more {{count}} character(s)...',
  common_cannot_be_empty: '{{field}} cannot be empty',
  common_select_option: 'Select Option...',
  search_placeholder: 'Search...',
  no_search_results: 'No results found',
  clear_selection: 'Clear selection',
  common_per_page: 'Rows per page',
  common_attributes: 'Attributes',
  common_not_started: 'Not started',
  common_in_progress: 'In progress',
  common_finished: 'Finished',
  common_start: 'Start',
  common_detail: 'View Details',
  common_delete: 'Delete',
  common_position: 'Position',
  common_average_key_score: 'Average key score',
  common_score: 'Score',
  common_score_scale: 'Score Scale',
  common_intensity: 'Intensity',
  common_report_not_have_data: 'The selected rounds had no votes',
  month_0: 'January',
  month_1: 'February',
  month_2: 'March',
  month_3: 'April',
  month_4: 'May',
  month_5: 'June',
  month_6: 'July',
  month_7: 'August',
  month_8: 'September',
  month_9: 'October',
  month_10: 'November',
  month_11: 'December',
  dropdown_change_picture: 'Change Picture',
  dropdown_language: 'Language',
  dropdown_logout: 'Log out',
  logout_title: 'Signing out, please wait…',
  logout_description: 'You are being logged out of your account.',
  round_not_started: 'Not Started',
  round_in_progress: 'In Progress',
  round_finished: 'Finished',
  round_filter_start: 'Start',
  round_round_type_in_profile: 'In-Profile',
  tasting_list_rounds: 'List Rounds',
  menu_tasting_session: 'Tasting Session',
  menu_panel_management: 'Panel Management',
  menu_process_management: 'Process Management',
  menu_product_management: 'Product Management',
  menu_attributes_management: 'Attributes Management',
  tasting_finish_sample: 'Finish Sample',
  tasting_comments: 'Comments',
  tasting_beer_profile: 'Beer Profile',
  tasting_need_select_score_comments:
    'You must set a score and add at least one comment to continue...',
  tasting_finish_taste: 'Finish Taste',
  tasting_finish_tasting: 'Finish Tasting',
  common_no_comments: 'No Comments',
  review_submit_title: 'Are you sure you are ready to submit your results?',
  review_submit_description: "You won't be able to edit later",
  review_finish_taste: 'Finish Taste',
  review_warning_sample_title: 'You have untasted samples!',
  review_warning_sample_description:
    'Do you wish to continue without tasting them?',
  review_warning_sample_review: 'Review',
  review_warning_sample_ok: 'Continue',
  review_warning_preference_description:
    'Please select a preference before proceeding.',
  review_warning_tie_sample_title: 'You have tie samples!',
  review_warning_tie_sample_description:
    'You cannot continue without rank them!',
  review_warning_tie_sample_review: 'Review',
  common_submit: 'Submit',
  common_discussion: 'Discussion',
  common_not_informed: 'Not informed',
  discussion_order_number: 'Order By Position',
  discussion_order_brewery: 'Order By Brewery',
  discussion_order_ranking: 'Order By Ranking',
  discussion_order_brand: 'Order By Brand',
  discussion_order_score: 'Order By Score',
  discussion_order_key_score: 'Order By Key Score',
  discussion_order_overall_rank: 'Order By Overall Rank',
  discussion_order_key_rank: 'Order By Key Rank',
  discussion_export_error: 'The file could not be saved!',
  discussion_ranking: 'Ranking',
  discussion_overall_ranking: 'Overall Ranking',
  discussion_key_ranking: 'Key Ranking',
  common_brewery: 'Brewery',
  common_trial_identifier: 'ID Trial',
  common_key_score: 'Key Score',
  round_report: 'Export to excel',
  common_comments: 'Comments',
  previous_comments: 'Previous comments',
  message_you_cannot_delete_all_comments:
    "You can't delete all comments when editing a vote",
  common_message_empty_profile: 'Profile name not permitted empty or blank',
  common_message_out_score_range: 'out of range score',
  tasting_need_select_score: 'You must set a score first!',
  common_category_name: 'Category',
  categories_new_category: 'New category',
  categories_remove_category: 'Do you really want to remove the category',
  categories_list_categories: 'Categories',
  categories_list_all_categories: 'All Categories',
  common_category_sample_name: 'Sample',
  categories_new_category_sample: 'New sample',
  categories_remove_category_sample: 'Do you really want to remove the sample',
  categories_list_categories_samples: 'Samples',
  tasting_help: 'Tasting Help',
  common_back: 'Back',
  common_next: 'Next',
  common_sample_id: 'Sample ID',
  common_sample_date: 'Sample Date',
  common_duplicate: 'Duplicate',
  tasting_raw_materials: 'Raw materials',
  tasting_example_sensory_risk:
    'Example of main sensory risk: non-conformity with expected taste',
  tasting_procedure: 'Process',
  tasting_sample_preparation: 'Sample preparation',
  tasting_help_comments: 'Comments',
  common_collection_point: 'Collection Point',
  common_collection_date: 'Collection Date',
  common_brew_number: 'Brew Numbers/MES number',
  common_need_explain_nok: 'You cannot have samples NOK without a comment!',
  common_percent_ok: 'Percentage OK',
  common_show_all: 'Show all',
  common_import: 'Import',
  common_download_template: 'Download Template',
  sample_import_message: 'xlsx',
  common_template: 'Template',
  common_yes: 'Yes',
  common_no: 'No',
  common_only_kpi_sample: 'Only KPI sample',
  common_need_volte_first: "You can't comment samples without a vote first!",
  common_name_template: 'Template Name',
  interaction_log: 'Interaction Log',
  common_message_zone_empty: 'Zone not permitted empty or blank',
  common_message_country_empty: 'Country not permitted empty or blank',
  common_message_site_empty: 'Site not permitted empty or blank',
  user_new_profile_save: 'New profile created',
  common_in_privileges: 'in privileges',
  common_download_files: 'Download Files',
  common_view_details: 'View Details',
  common_create_action: 'Create Action',
  common_action_list: 'Action List',
  common_create_action_description: 'Fill in action details for this sample.',
  common_optional: 'optional',
  action_deadline: 'Deadline',
  action_description: 'Action Description',
  action_description_autofill_tooltip: 'Action Description',
  action_description_autofill_tooltip_description:
    'Auto-generated (Round ID / Brewery / Sample Name / Production Date / Create User) + additional description',
  action_owner: 'Owner',
  action_meeting: 'Interaction Log Meeting',
  action_meeting_list: 'IAL Meeting',
  action_producing_site: 'Producing Site',
  action_production_date: 'Production Date',
  action_closed_time: 'Closed Time',
  action_meeting_placeholder: 'Please select meeting',
  action_status: 'Status',
  action_status_draft: 'Draft',
  action_status_not_started: 'Not Started',
  action_status_in_progress: 'In Progress',
  action_status_delayed: 'Delayed',
  action_status_close: 'Closed',
  action_status_canceled: 'Canceled',
  status_record: 'Status Record',
  no_status_record: 'No status records',
  action_type: 'Action Type',
  action_create_user: 'Create User',
  action_create_time: 'Create Time',
  action_root_cause: 'Root Cause',
  action_description_placeholder: 'Please enter action description...',
  action_root_cause_placeholder: 'Please enter root cause...',
  action_owner_placeholder: 'Please select an action owner',
  action_created_successfully: 'Action was successfully created!',
  action_created_successfully_desc:
    'Check out the created action in the action list.',
  action_updated_successfully: 'Action was successfully updated!',
  action_updated_successfully_desc:
    'Check out the updated action in the action list.',
  action_create_failed: 'There was a problem creating action',
  action_update_failed: 'There was a problem updating action',
  action_update_failed_desc: 'Please try again in a moment.',
  action_save_failed_desc: 'Please try again in a moment.',
  action_deleted_successfully: 'Action was successfully deleted!',
  action_deleted_successfully_desc: 'Check it out in the action list.',
  action_delete_failed: 'There was a problem deleting action',
  action_change_status_successfully: 'Status Changed!',
  action_change_status_successfully_desc:
    'The action status was changed to {{status}}.',
  action_change_status_failed: 'There was a problem changing the status',
  action_change_status_failed_desc:
    'The action status could not be changed. Please try again.',
  delete_action_confirm_title: 'Delete action?',
  delete_action_confirm_description:
    'This action will be permanently removed. Are you sure you want to continue?',
  action_added_notification: '[{{userName}}] added new action',
  action_updated_notification: '[{{userName}}] updated their action',
  action_deleted_notification: '[{{userName}}] deleted their own action',
  view_action_list: 'View Action List',
  pdf_viewer: 'Viwer PDF',
  common_all: 'All',
  common_continue: 'Continue',
  common_minimum_score: 'Min',
  common_maximum_score: 'Max',
  common_average_score: 'Avg',
  file_upload_fail: 'Failed to upload the file, the following errors occured: ',
  file_upload_success_with_error:
    'The upload was successful except for the following: ',
  missing_fields: 'missing fields',
  column_error: 'column error',
  common_line: 'Line',
  file_no_samples: 'No samples found on the file!',
  file_success_upload: 'Success upload file!',
  file_duplicated_kpi_project: 'Duplicated KPI or Project',
  round_schedule_maximum_length:
    'The maximum length of the round name is 40 characters.',
  sample_malt_varieties: 'Malt Variety',
  error_sample_already_in_round: 'The sample is already in the round',
  malt_varieties_has_no_english_name:
    'You must have at least one malt varieties name.',
  malt_varieties_duplicate:
    'Attention: There is a variety of malt with this name',
  malt_varieties_remove: 'Remove Variety',
  malt_varieties_new: 'New Variety',
  malt_varieties_edit: 'Edit Variety',
  malt_varieties_enter_name: 'Enter name',
  malt_varieties_page_description:
    'Manage all malt variety and their configurations in one place.',
  malt_varieties_save_success: 'Malt variety successfully created!',
  malt_varieties_save_success_desc: 'Check it out in the malt variety below.',
  malt_varieties_update_success: 'Malt variety successfully updated!',
  malt_varieties_update_success_desc: 'Check it out in the malt variety below.',
  malt_varieties_delete_title: 'Remove malt variety?',
  malt_varieties_delete_description:
    '{{name}} malt variety will be permanently removed. Are you sure you want to continue?',
  malt_varieties_delete_success: 'Malt variety successfully deleted!',
  malt_varieties_delete_success_desc: 'Check it out in the malt variety below.',
  malt_varieties_delete_failed: 'Malt variety failed to delete.',
  malt_varieties_delete_failed_desc: 'Please try again in a moment.',
  cancel_new_malt_variety_title: 'Cancel new malt variety?',
  cancel_edit_malt_variety_title: 'Cancel malt variety edit?',
  cancel_new_malt_variety_confirm: 'Cancel new malt variety',
  cancel_edit_malt_variety_confirm: 'Cancel malt variety edit',
  reports_no_dates: 'Start Date and End Date are mandatory!',
  reports_date_range_message:
    'The range of dates cannot be bigger than 1 year!',
  round_save_select_site: 'To save a round you must select a site',
  common_error: 'Oops! Something went wrong, please try again',
  common_horizontal: 'Horizontal Layout',
  common_unit: 'Unit',
  common_supplier: 'Supplier',
  common_flavor: 'Flavor',
  concentration_of_the_base_beer: 'Concentration of the base beer',
  threshold_aml_method: 'AML Method (Ascending Method of Limits)',
  threshold_component_concentration: 'Component Concentration',
  threshold_sample_different_help: 'Which sample is different?',
  threshold_each_set_random_order: 'In each set, random order.',
  threshold_select_base_beer: 'Select Base Beer',
  common_unity: 'Unity',
  common_finish_session: 'Finish Taste',
  common_filters: 'Filters',
  review_submit_threshold: 'Are you sure you want to save?',
  threshold_coder_wrong:
    'The code entered is wrong. Please enter the corrected code.',
  threshold_didnt_enter_the_code: 'Please enter your code',
  code: 'Code',
  common_batch_code: 'Batch Code',
  threshold_samples_required: 'Base beer and Flavor are required',
  threshold_information_helper_sample:
    'To save threshold sample information, please click on the Save button to keep your changes',
  code_digits: 'Enter the 3 digits code assigned to you',
  threshold_sample_spiked_with:
    'On each set, choose the sample that has been spiked with ',
  threshold_code_already_tasted:
    'This code has already been tasted by another user. Enter another code.',
  common_kpi_brands: 'KPI Brands',
  common_year: 'Year',
  common_new_kpi_brand: 'New KPI Brand',
  common_new_kpi_brand_button: 'New KPI brand',
  common_edit_kpi_brand: 'KPI Brand Edit',
  common_target: 'Target',
  common_focus_brands: 'Focus Brands',
  common_strategic_brands: 'Strategic Brands',
  kpi_brands_new_page_description:
    'Create New KPI Brand interface, with functions to fill in KPI Brand information, submit, and save.',
  kpi_brands_edit_page_description:
    'Edit KPI Brand interface, with functions to update KPI Brand information, submit, and save.',
  kpi_brands_edit_page_description_prefix: 'View and configure KPI Brands for ',
  kpi_brands_page_description:
    'KPI Brands management interface, with view, submit, and review functions.',
  kpi_brand_details_title: 'KPI Brand Details',
  kpi_brand_details_description:
    'View complete information and approval process status.',
  approval_action: 'Approval Action',
  select_approval_action: 'Select approval action',
  reject_reason_title: 'Reject Reason',
  reject_reason_description: 'Please provide a reason for rejection.',
  reject_reason_label: 'Rejection reason',
  reject_reason_placeholder: 'Enter rejection reason...',
  reject_reason_placeholder_site:
    "Please enter the reason for rejecting this site '{{site}}'...",
  common_confirm: 'Confirm',
  common_success: 'Success',
  common_save_failed: 'Failed to save. Please try again.',
  approval_status_saved_success: 'Approval status has been saved successfully!',
  common_action: 'Action',
  common_comment_by_category: 'Comments by Category',
  common_alphabetic_comment: 'Alphabetical Comments',
  common_name_pts_code: 'PTS code',
  common_name_pts_code_placeholder: 'Code',
  common_name_process_item: 'Process Item',
  common_name_process_item_placeholder: 'Item',
  common_global_brands: 'Global Brands',
  common_global_brand: 'Global Brand',
  common_target_global_brand: 'Target for Global Brand',
  common_focus_brand: 'Focus Brand',
  common_target_focus_brand: 'Target for Focus Brand',
  common_strategic_brand: 'Strategic Brand',
  common_target_strategic_brand: 'Target for Strategic Brand',
  common_maximun_sites: 'Maximun sites to compare is',
  common_state_reason_rejecting: 'State the reason for rejecting for this site',
  common_rejected_note: 'Rejected note',
  report_list_report_kpi: 'KPI Reports',
  report_list_report_taste: 'Tasting Reports',
  report_list_report_evaluation: 'Evaluation Report',
  report_list_report_brand: 'Brand Report',
  report_list_report_physchem: 'Physchem Reports',
  taster_evaluation_report: 'Taster Evaluation Report',
  kpi_gbsi_bssi_dispersion: 'GBSI BSSI & Dispersion',
  kpi_freshness: 'Freshness KPI',
  select_brand_to_filter: 'Select a Global Brand!',
  select_year_to_filter: 'Select a Year!',
  kpi_only_numbers_warning: 'Accept only numbers on Target values',
  kpi_max_number_range_warning: 'Your Target Brand must be between 1 and 9',
  kpi_already_selected_brand_warning:
    'You have this brand selected, please choose another brand',
  kpi_no_kpi_informed_warning:
    'No KPI value has been entered. Please add the value.',
  kpi_select_year_warning: 'Select a year',
  kpi_select_site_warning: 'Select a site',
  kpi_existing_configuration_warning:
    'You have kpi values from same site and year',
  kpi_target_empty_warning: 'A target of one of your brands is empty',
  kpi_saved_successfully: 'Your values ​​have been saved successfully!',
  kpi_submitted_successfully: 'Your values ​​have been submitted successfully!',
  kpi_max_decimals_warning: 'Your target value must be up to 3 decimal',
  kpi_count_as_kpi_sample: 'Count as KPI',
  samples_uncheck_kpi_sample_tooltip:
    "Uncheck this box if you don't want this sample to count in the KPI",
  reports_mandatory_zone_filter: 'Select at least one zone',
  common_approve_reject: 'Approve/Reject',
  common_approve: 'Approve',
  submission_type: 'Submission type',

  custom_scale_title: 'Customized Scale',
  custom_scale_grid_header_score: 'Score',
  custom_scale_grid_header_ageind_scale: 'Forced Ageing Scale',
  the_value_cannot_be_null: 'The value cannot be null!',
  unique_id: 'Unique ID',
  report_filter_rounds_description:
    'You must select the mandatory fields to load rounds options.',
  reports_mandatory_test_type: 'Select the test type.',
  round_reports_month_warning:
    'The period between the start date and the end date must be a maximum of 6 months.',
  zone_can_not_empty: 'Zone can not be empty!',
  error_loading_data:
    'Error loading data.Please check your connection and reload.',
  flavor_identification: 'Flavor ID',
  flavor_id_discussion: 'Flavor ID Discussion',
  view_and_discussion_for: 'View and discuss for',
  common_cup: 'Cup',
  tasters_joined: 'Tasters Joined',
  tasters_all_correct: 'Tasters All Correct',
  total_accuracy: 'Total Accuracy',
  accuracy: 'Accuracy',
  all_correct: 'All Correct',
  otherwise: 'Otherwise',
  result: 'Result',
  Key: 'Key',
  nonkey: 'Nonkey',
  common_guest: 'Guest',
  view_correct_answers: 'View correct answers',
  hide_correct_answers: 'Hide correct answers',
  change_to_table: 'Change to table',
  change_to_card: 'Change to card',
  not_answered: 'Not answered',
  beer_batch: 'Beer batch',
  list_of_beers: 'List of beers',
  random: 'Random',
  preview: 'Seat Preview',
  select_the_flavor: 'Select the flavor',
  flavor_threshold: 'Flavor Threshold',
  input_digital_number: 'Input digital number...',
  concentration: 'Concentration',
  flavor_order: 'Flavor Order:',
  last: 'Last',
  tasting: 'Tasting',
  tasting_page_description:
    'Perform sample tasting evaluation and discuss the result.',
  confirmation: 'Confirmation',
  do_you_confirm_the_evaluation_of_this_sample:
    'Do you confirm the evaluation of this sample?',
  confirm: 'Confirm',
  evaluate: 'Evaluate',
  correct_answer: 'Correct Answer',
  threshold: 'Threshold',
  let_a_comment_about_the_tasting: 'Let a comment about the tasting',
  send: 'Send',
  right_now: 'Right Now',
  minute_ago: 'm ago',
  hour_ago: 'h ago',
  day_before: 'd before',
  year_ago: 'y ago',
  add_a_flavor: 'Add a flavor',
  soft_drinks: 'Soft Drinks Brands',
  soft_drinks_brand: 'Soft Drink Brand',
  soft_drinks_brand_target: 'Soft Drink Brand Target',
  column_options: 'Column Options',
  configure_table_title: 'Customize columns',
  configure_table: 'Configure Table',
  configure_table_description:
    'Choose which columns are visible and how they are arranged.',
  configure_table_helper:
    'There must be at least 2 visible columns, and a maximum of 4 fixed columns.',
  configure_table_fixed_left: 'Fixed left',
  configure_table_scroll_area: 'Scroll area',
  configure_table_fixed_right: 'Fixed right',
  configure_table_empty_left: 'Drag a column here to fix it on the left',
  configure_table_empty_right: 'Drag a column here to fix it on the right',
  configure_table_save: 'Save changes',
  configure_table_reset: 'Reset to default',
  configure_table_discard: 'Discard changes',
  configure_table_show: 'Show',
  configure_table_hide: 'Hide',
  configure_table_min_visible: 'At least two columns must remain visible',
  configure_table_max_fixed: 'You can fix up to four columns',
  configure_table_drag: 'Drag to reorder',
  configure_table_dragging: 'Dragging',
  select_which_of_the_columns_do_you_want_to_be_displayed:
    'Select which of the columns do you want to be displayed.',
  countdown: 'Countdown',
  less_than_five_minutes:
    'This tasting session will end in 5 minutes,  if you need to proceed, please contact admin to delay finish date.',
  the_countdown_to_the_evaluation_has_ended:
    'You can not enter as the countdown of this tasting session has ended',
  counting_how_much_time_does_you_have_to_finish_tasting_the_samples:
    'Counting how much time does you have to finish tasting the samples',
  only_six_flavors_can_be_added_at_most: 'Only 6 flavors can be added at most!',
  concentration_of_the_flavor: 'Concentration of the flavor',
  input_value: 'Please enter',
  Concentration_of_the_flavor_is_required:
    'Concentration of the flavor is required',
  previous_round: 'Previous Round',
  next_round: 'Next Round',
  the_end_time_is_greater_than_the_current_time:
    'The end time must be greater than the current time, if you select the same day as the current day, select the hour and minute first!',
  check_the_answer_at_the_end_of_the_countdown:
    'Please wait until the countdown goes to zero to check the result.',
  incremental_step: 'Incremental Step',
  set3_concentration: 'Set3 Concentration',
  concentration_increments_between_levels:
    'Concentration increments between levels',
  incremental_set3_concentration_required:
    'Incremental Step and Set3 Concentration are required',
  sprint: 'Sprint',
  sprint_number_greater_than_zero: 'Sprint number must be greater than 0',
  sprint_notes_at_least_one_note: 'Sprint notes must have at least one note',
  sprint_patch_notes_success_update: 'Sprint patch notes updated with success.',
  sprint_patch_notes_error_update: 'It was not possible to save the notes.',
  sprint_number: 'Sprint Number',
  sprint_patch_notes: 'Sprint patch notes',
  note: 'Note',
  select_all: 'Select All',
  please_add_samples_first: 'Please add samples first',
  reverse: 'Reverse',
  score_scale: 'Ab InBev scale',
  description: 'Description',
  aditional_criteria: 'Aditional Criteria',
  new_test: 'New Test',
  triangle_test: 'Triangle Test',
  triangle_test_name: 'Triangle Test Name',
  you_can_not_set_three_identical_samples:
    'You can not set 3 identical samples',
  its_mandatory_to_input_test_name: "It's mandatory to input Test Name.",
  its_mandatory_to_input_sample_information:
    "It's mandatory to input Sample Information.",
  attention: 'Attention',
  test_number: 'Test Number',
  you_selected_the: 'You selected the',
  next_sample: 'Next Sample',
  remove_triangle_test: 'Remove Triangle Test',
  test: 'Test',
  confirm_remove: 'Do you confirm to delete this test?',
  you_can_only_select_up_to_five: 'You can only select up to 5 varieties.',
  reports_mandatory_zone_country_site_filter:
    'Zone, Country, Site are mandatory!',
  reports_mandatory_brand_filter: 'Select at least one brand',
  download_label: 'Download Label',
  reports_by_producing_site: 'Reports by Producing Site',
  standard: 'Standard',
  input_test: 'Input Test',
  detecting: 'Detecting···',
  connected: 'Connected',
  current_taster: ' Current Taster',
  alcohol_concentration: 'Alcohol Concentration',
  alcohol_result_submit_failed_title:
    'There was a problem submitting the result',
  alcohol_result_submit_failed_desc: 'Please try again in a moment.',
  your_alcohol_test_result_exceeds_standard_please_test_again_later:
    'Your alcohol test result exceeds standard. Please test again later!',
  alcohol_test_qualified: 'Alcohol test qualified',
  alcohol_test_qualified_title: 'Alcohol test qualified!',
  alcohol_test_qualified_desc:
    'The breathalyzer result is within the acceptable range.',
  alcohol_test_result_exceeds_standard:
    'Your alcohol test result exceeds standard',
  alcohol_test_result_exceeds_standard_desc: 'Please test again later.',
  alcohol_result_save_failed: 'Unable to save the alcohol test result.',
  alcohol_concentration_configuration: 'Alcohol Concentration Configuration',
  breathalyzer_configuration_description:
    'Configure the Alcohol Concentration for each site and the driving status of the users.',
  breathalyzer_configuration_save_success_title:
    'Breathalyzer configuration was successfully updated!',
  breathalyzer_configuration_save_success_description:
    'Check out the updated configurations in the settings below.',
  breathalyzer_configuration_save_failed_title:
    'There was a problem updating Breathalyzer configuration',
  breathalyzer_configuration_save_failed_description:
    'Please try again in a moment.',
  cancel_configuration_title: 'Cancel configuration?',
  cancel_configuration_description:
    'You have made changes to the configuration. Canceling will discard your unsaved changes. Are you sure you want to continue?',
  cancel_configuration_confirm: 'Cancel configuration',
  driving_configuration: 'Driving Configuration',
  configuration: 'Configuration',
  input_result: 'Input Result',
  maximum_alcohol_concentration: 'Excess Alcohol Concentration',
  breathalyzer: 'Breathalyzer',
  breathalyzer_page_description:
    'Manage all breathalyzer results and their configuration standards in one place.',
  please_input_a_positive_number_up_to_n_decimal_places:
    'Please input a positive number up to {{field}} decimal places',
  you_must_input: 'You must input',
  driving: 'Driving',
  test_time: 'Test Time',
  input_type: 'Input Type',
  list_breathalyzer: 'Breathalyzer',
  Manual: 'Manual',
  Breathalyzer: 'Breathalyzer',
  you_do_not_have_privilege_to_export_this_report:
    'You do not have privilege to export this report',
  competitor_beer: 'Competitor Beer',
  split_round: 'Split Round',
  reset: 'Reset',
  how_many_rounds_splitting_do_you_want_to_make:
    'How many rounds of splitting do you want to make',
  you_cannot_split_a_round_that_has_already_been_split_or_in_progress:
    'You cannot split a round that has already been split or in-progress',
  hide_sample_details: 'Hide Sample Details',
  hide_sample_details_auto_hide:
    'YES - you can split the samples and auto show up all hidden info after all splitted rounds tasted.',
  hide_sample_details_manual_hide:
    'Manual - you can not split the samples and need to assign a temporary admin to manually switch Unhide or Hide in discussion page.',
  data_will_be_hidden_from_the_taster_brewery_production_date_brand_malt_variety_and_sample_id:
    'Data will be hidden from the tasters: Brewery, Production date, Brand, Malt Variety and Sample ID',
  this_round_is_selected_manual_unhide_split_function_is_not_available_you_can_choose_auto_hide_or_no_hide_to_split:
    'This round is selected Manual, split function is not available, you can choose Auto Hide or No Hide to split.',
  data_will_be_hidden_for_ok_nok:
    'All relevant data will be hidden from tasters',
  you_can_not_add_duplicate_attributes: 'You can not add duplicate attributes.',
  menu: 'MENU',
  link_breathalyzer: 'Connected',
  not_link_breathalyzer: 'Unconnected',
  breathalyzer_to_link: 'Connect breathalyzer',
  breathalyzer_connection_failed_title: 'Breathalyzer connection failed',
  breathalyzer_connection_failed_desc: 'Please refresh the page and try again.',
  breathalyzer_can_not_to_link_for_this_browser:
    'The breathalyzer capability is developed to work on Google Chrome, using PC devices.',
  reopen: 'Reopen',
  round_reopen_message: 'Are you sure you want to reopen the Round',
  common_production_line: 'Production line',
  common_packaged_beer_data_code: 'Packaged Beer Data Code',
  common_masking_process_for_bottles: 'Masking Process for Bottles',
  common_str_number_days_over_aged: 'Number of days when over-aged',
  common_over_aged_beer: 'Over-aged Beer',
  sample_successfully_swapped: 'Sample successfully swapped.',
  scoring: 'Scoring',
  configure_available_flavors: 'Configure Available Flavors',
  process_check: 'Process Check',
  new_process_check: 'New Process Check',
  edit_process_check: 'Edit Process Check',
  remove_process_check: 'Remove Process Check',
  common_package: 'Package',
  common_department: 'Department',
  common_shift: 'Shift',
  common_tank: 'Tank',
  common_oknok: 'OKNOK',
  common_remark: 'Remark',
  show_all_process_check: 'Show All Process Check',
  show_all_process_check_help_circle:
    'Showing Process Check created six months from today, Check this box if you also want to see Process Check created one year from today',
  the_sample_date_cannot_be_earlier_than_the_current_time:
    'The Sample Date cannot be greater than the current time!',
  common_job_position: 'Job Position',
  decimal_sep: 'Decimal Sep',
  is_swapped_to: 'swap to',
  review_warning_comment_title: 'You have uncommented samples!',
  continuous_typing: 'Continuous Typing',
  continuous_typing_tips:
    "Countinue typing 'Attribute' after selecting/typing 'Intensity'.",
  BSSI_Reports: 'BSSI Reports',
  data_analysis_sip: 'Data Analysis - SIP',
  select_the_color: 'Select the color',
  color: 'Color',
  download_document: 'Download Documents',
  Month_of_Discontinued_Production: 'Month of Discontinued Production',
  Suspension_List: 'Suspension List',
  New_Suspension: 'New Suspension',
  new_suspension_page: 'New Suspension',
  edit_suspension_page: 'Edit Suspension',
  Brand_name: 'Brand Name',
  List_Brewery_Production_Suspension: 'Brewery Production Suspension List',
  Upload_successfully: 'File uploaded successfully!',
  training_materials: 'Training Materials',
  Remove_Suspension: 'Remove Suspension: ',
  Add_Absence_Reason: 'Add absence reason',
  Reason: 'Reason',
  Select_reason: 'Select reason',
  You_have_duplicate_absence_dates: 'You have duplicate absence dates',
  absence_save_success: 'Add absence reason successfully!',
  absence_save_success_desc: 'Check it out in the submitted absence.',
  submitted_absence: 'Submitted absence',
  no_absence_to_show: 'No absence to show',
  no_more_data: 'No more data',
  absence_delete_success: 'Absence reason successfully deleted!',
  absence_delete_success_desc: 'Check the updated list in submitted absence.',
  absence_delete_confirm_title: 'Delete absence?',
  absence_delete_confirm_description:
    'Absence record [{{start}} - {{finish}}] will be permanently removed. Are you sure you want to continue?',
  absence_delete_confirm_delete: 'Delete',
  absence_save_failed: 'Failed to add absence reason',
  absence_save_failed_desc: 'Please try again in a moment.',
  absence_duplicate_date_desc:
    'An absence record already exists for the selected date. Duplicate submissions are not allowed.',
  absence_delete_failed: 'Failed to remove absence reason',
  absence_delete_failed_desc: 'Please try again in a moment.',
  Remove_Absence: 'Remove absence: ',
  Absence_Title:
    'Please select tasting absence time and reason. View or delete entries in Submitted Reason.',
  Shipping_Site: 'Shipping Site',
  shipping_received: 'Shipping Received',
  receive_sample_alert: 'Are you sure you have received the sample?',
  receive_uncheck_alert: 'Are you sure you want to uncheck it?',
  all_received: 'All Received',
  not_all_received: 'Not All Received',
  not_for_shipping: 'Not For Shipping',
  receive_hint: 'Select all sites that will be receiving this sample',
  absence_reason: 'Absence Reason',
  Page1: 'Page {{field}}',
  Search: 'Search',
  page_total: 'Total',
  start_date: 'Start Date',
  end_date: 'Finish Date',
  ok_for_all: 'Ok for all',
  last_days: 'Last {{field}} days',
  today: 'Today',
  its_mandatory_to_select_sample_A_and_sample_B:
    "It's mandatory to select sample A and sample B.",
  its_mandatory_to_select_sample_A: "It's mandatory to select sample A.",
  its_mandatory_to_select_sample_B: "It's mandatory to select sample B.",
  triangle_comment: 'Comment',
  select_sample: 'Select Sample',
  sample_date_filter_last_7_days_in_default_export_to_Excel_based_on_this_filtered_duration:
    'Sample Date filter, last 7 days in default, export to Excel based on this filtered duration.',
  select_all_flavor: 'Select All',
  deselect_all: 'Unselect All',
  email_distribution: 'Monthly Report Recipients',
  recipients: 'To',
  cc_recipients: 'CC',
  new_email_distribution: 'New Monthly Report Recipients',
  edit_email_distribution: 'Edit Monthly Report Recipients',
  distribution_type: 'Distribution Type',
  the_score_entered_is_invalid:
    'The score entered is invalid.  Please refer to the score scale and enter your score again.',
  service_now:
    'Click to create an incident ticket to report an issue and get help.',
  service_now_tips:
    'Hey, if you see any issue or would like to ask for support you can click here and report it directly in serviceNow, our support team will get in touch with you as soon as possible.',
  done: 'Done',
  changes_you_made_may_not_be_saved:
    'Changes you made may not be saved. Do you want to continue and lose changes?',
  cannel_auto_save_tips:
    'Now the performance of tasting page is improved, please remember to click Finish Sample to save and submit your tasting result.',
  list_email_page_tips:
    'This is the instruction of how to setup correct KPI sample, in order to make sure the Zone Monthly Report can reflect exact analysis for your zone MCS tasting',
  list_email_page_helps:
    'The instruction of how to setup KPI sample to reflect exact data in your Zone Monthly Report.',
  kpi_instruction: 'KPI Instruction',
  group_no_recipients_message: 'At least one recipient is needed.',
  the_current_distribution_type_already_exists:
    'The current distribution type already exists, please reselect the type or return the list.',
  distribution_type_message_empty:
    'Distribution Type not permitted empty or blank',
  add_samples: 'Add sample(s) to the Round',
  copy_this_sample: 'Duplicate the sample',
  remove_this_sample: 'Remove the Sample',
  drag_samples_here: 'Drag samples here',
  drop_here: 'Drop here',
  multiple_selection_tips: `You can select several samples at once for the same sample type. Click on '+' and '-' to try it out.`,
  all_add_once_tips: `Click on the 'Select All' button to automatically add 1 sample to each selected sample type.`,
  copy_confirm_tip: 'Are you sure you want to copy the sample?',
  user_non_abi_user: 'New Temporary User',
  language_of_email_invitation: 'Language of Email Invitation',
  add_non_abi_users_to_round:
    'Temporary user will be receiving email invitation with a link to attend the specific tasting.',
  change_non_abi_users_to_round:
    'Temporary taster you invited will be receiving email invitation with a link to attend this tasting.',
  guest: 'Guest',
  email_to_all: 'Email To All',
  send_email: 'Send invitation email',
  temporary_non_abi_taster: 'Temporary Taster',
  user_type: 'User Type',
  email_invitation_delivery_request_sent: 'Round invitation email is sent!',
  incorrect_e_mail_formatting: 'Incorrect e-mail formatting',
  all_tasters: 'All Tasters',
  tasters: 'Tasters',
  key_tasters: 'Key Tasters',
  non_key_tasters: 'Non Key Tasters',
  taster_already_started_cannot_change:
    'Taster has already started, cannot be changed',
  temporary: 'Temporary User',
  maximum_number_of_samples_is: 'Maximum number of samples is',
  sample_added: 'Samples added',
  click_to_view_scale_of_flavour_intensities:
    'Click the link to see the detailed intensity scales',
  list_next_week_plan: 'Planning Week Sessions',
  common_time_zone: 'Time Zone',
  common_last_response_time: 'Last Response Time',
  new_week_plan: 'New Week Sessions',
  invited_week: 'Invited Week',
  email_language: 'Email Language',
  save_and_send_email: 'Save and send email invitation',
  common_start_time: 'Start Time',
  common_end_time: 'End Time',
  session_name_email_subject: 'Session Name / Email Subject',
  location: 'Location',
  calendar_confirm: 'Calendar Confirm',
  edit_week_plan: 'Edit Week Sessions',
  common_session: 'Sessions',
  round_remove_plan: 'Are you sure you want to delete the plan',
  email_response: 'Email Response',
  are_you_confirming_to_send_the_invitation_email:
    'Are you confirming to send the invitation email',
  view_week_plan: 'View Week Sessions',
  are_you_confirming_to_send_the_confirmation_email:
    'Are you confirming to send the confirmation email',
  every_10_minutes_system_will_update_the_email_response_from_next_week_plan_invitation:
    'Every 10 minutes system will update the email response from planning week sessions invitation',
  documents_upload_tips: 'File upload only supports {{field}}',
  ignore_submit: 'Ignore&Submit',
  if_count_as_kpi:
    'If this is necessary for the calculation of BSSI and GBSI, don’t forget to ‘Count as KPI’ for the sample KPIs below',
  confirmed_count: 'Confirmed Count',
  accepted: 'Accepted',
  declined: 'Declined',
  no_response: 'No Response',
  apply_to_all_sessions: 'Apply To All Sessions',
  reminder_time: 'Reminder Time',
  are_you_sure_you_want_to_change_the_week_of_invitation:
    'Are you sure you want to remove the Session Start/End Time you have selected, and change to another Invited Week',
  apply_to_all_sessions_location_tasters:
    'Apply "Location" and "Tasters" to following sessions',
  upload_tasters: 'Upload Tasters',
  mcs_tasting: 'KPI Tasting',
  qcs_tasting: 'KPI Tasting',
  mcs_tasting_tips:
    'Select Yes if this round contains MCS/KPI samples, system will apply related KPI Code per the sample brand.',
  round_samples_shuffle_confirm: 'Are you sure you want to shuffle the Sets?',
  all_count_as_kpi: 'All Count as KPI',
  msc_tasting_tour_mask:
    'System will identify related KPI Code automatically based on counted sample with right KPI Month, so you DO NOT have to split different brands in one round',
  competition: 'Competition',
  copy_link: 'Copy Link',
  open_link: 'Open Link',
  common_download_img: 'Download IMG',
  please_select_taster: 'Please chose your name',
  qr_code: 'QR Code',
  global_id: 'Global ID',
  user_principal_name: 'User Principal Name',
  user_status: 'User Status',
  termination_date: 'Termination Date',
  function_level: 'Function Level',
  last_update_time: 'Last Update Time',
  system_related: 'System Related',
  workday_related: 'WorkDay Related',
  employee_id: 'Employee ID',
  zitec_project_name: 'Project Name',
  applicant: 'Applicant',
  applicant_date: 'Application Date',
  test_method: 'Test Method',
  liquid_category: 'Liquid Category',
  conditions: 'Conditions',
  time_points: 'Time Points',
  execution_date: 'Execution Date',
  execution_by_time_points: 'Calculated Execution Date By Time Points',
  invitation_start_time: 'Invitation Start Time',
  invitation_end_time: 'Invitation End Time',
  invitation_reminder: 'Invitation Reminder',
  application_form: 'Application Form',
  application_form_result: 'Application Form Result',
  upload_result: 'Upload Result',
  zitec_sessions: 'ZITEC Sessions',
  zitec_id: 'ZITEC ID',
  new_zitec_session: 'New ZITEC Session',
  common_search_applicant: 'Search Applicant',
  history_record: 'History Record',
  auto: 'Auto',
  common_quarterly: 'Quarterly',
  common_month: 'Month',
  kpi_report: 'KPI Report',
  kpi_result: 'Anaplan File',
  action_log: 'Action Log',
  validate_data: 'KPI Confirmation',
  push_anaplan_window_open_date: 'Push Anaplan Window Open Date:',
  unLock_kpi: 'Unlock',
  lock_kpi: 'Lock',
  locked: 'Locked',
  unlocked: 'Unlocked',
  menu_kpi_lock: 'KPI Lock',
  freshness_kpi_lock: 'Freshness Lock',
  in_profile_kpi_lock: 'In Profile Lock',
  are_you_sure_you_want_to_lock_kpi:
    'Are you sure you want to lock KPI for {{field}}',
  are_you_sure_you_want_to_unlock_kpi:
    'Are you sure you want to unlock KPI {{field}}',
  lock_kpi_month_zone:
    'Your action is restricted due to the lock of KPI sample that actived for given KPI month and zone. If you have question, please contact your zone owner for more details about the KPI data locking.',
  lock_freshness_kpi_month_zone:
    'Your action is restricted due to the lock of KPI sample that actived for given KPI quarter and zone. If you have question, please contact your zone owner for more details about the KPI data locking.',
  submit_timeout: 'Failed to submit, please try again later!',
  anaplan_un_upload_tips: 'Please wait for next Anaplan open window',
  anaplan_un_confirm_tips: 'Please confirm the KPI data for given month!',
  confirmed: 'Confirmed',
  confirm_data: 'Confirm Data',
  flavor_groups: 'Flavor Groups',
  compound: 'Compound',
  sit_code_not_exist:
    'This seat code does not exist, please be aware of seat code format such as 001, 002.',
  sit_code_chose:
    'This seat code has been chosen, please input your correct seat code.',
  kpi_lock: 'KPI Lock',
  kpi_confirmation: 'KPI Confirmation',
  global_kpi_lock: 'Global KPI Lock',
  date_range: 'Date Range',
  kpi_month_range: 'Month Range',
  quick_select: 'Quick select',
  current_month: 'Current Month',
  current_year: 'Current Year',
  a_whole_year: 'A Whole Year',
  first_half_of_the_year: 'H1',
  second_half_of_the_year: 'H2',
  select_month: 'Select a Month',
  need_to_wait_global_lock: 'You need to wait for Global to lock.',
  monthly_kpi_locked_zones: 'Monthly KPI Locked Zones',
  flavor_confirm_save: `The unselected flavor '{{field}}' are in the added samples. If you confirm to save current flavor configuration, the corresponding samples will be deleted`,
  temporary_admin: 'Temporary Admin',
  unhide_sample_details: 'Unhide Sample Details',
  hide_sample: 'Hide Sample',
  download_report_timeout_error_message:
    'Timeout access, please check the network connection',
  download_report_success: 'Reports successfully downloaded!',
  download_report_success_desc: 'Check them out in your downloads folder.',
  download_self_evaluation_report_success:
    'Self Evaluation Report downloaded successfully!',
  download_report_failed: 'Failed to download reports.',
  download_report_failed_desc: 'Please try again in a moment.',
  evaluation_report_add_success: 'Report successfully added!',
  evaluation_report_add_success_desc:
    "Check them out in your 'To Download' evaluation report.",
  evaluation_report_add_failed: 'Failed to add report.',
  evaluation_report_add_failed_desc: 'Please try again in a moment.',
  you_can_only_select_up_to:
    'You can only select up to {{field}}, please reduce the number of choices.',
  push_anaplan: 'Push Anaplan',
  pushed: 'Push Completion',
  self_evaluation_report: 'Click to download Self Evaluation Report',
  download_self_evaluation_report: 'Download Self Evaluation Report',
  select_tasters: 'Select Tasters',
  create_ticket: 'Create Ticket',
  sensory_intelligent_platform: 'Sensory Intelligent Platform - PBI',
  external_links: 'External Links',
  evaluation_report: 'Evaluation Report',
  download_evaluation_report: 'Download Taster Evaluation Report',
  taster_type: 'Taster Type',
  taster_evaluation_tip:
    'Now you can click here to download your Self Evaluation Report!',
  admin_evaluation_tip:
    'Now you can click here to download Tasters Evaluation Report!',
  kpi_sample: 'KPI Sample',
  add_to_download_list: 'Add to download list',
  to_download_list: 'Download list',
  selected_tasters: 'Selected Tasters',
  generation_time: 'Generation Time',
  start_month: 'Start Month',
  end_month: 'End Month',
  download_all: 'Download All',
  file_name: 'File Name',
  report_type: 'Report Type',
  report_global: 'Global Brands Results',
  report_user: 'Users',
  physchem: 'Physchem',
  physchem_disabled_tips: 'Unable to view phychem when samples hide',
  new_physchem_tips: 'Now you can click here to add physchem for sample',
  view_physchem_tips: `Now you can click here to view samples' physchem of the current round`,
  package_code: 'Package Code',
  concentration_at_fu: 'Concentration at 1 Flavor Unit',
  base_beer: 'Base Beer',
  flavor_intensities_scale: 'Flavor Intensities Scale',
  flavor_unit: 'Flavor Unit',
  add_a_sample: 'Add a Sample',
  common_kpi_quarter: 'KPI Quarter',
  sample_duplicated_quarter_kpi_message:
    'There is already a KPI for the quarter, brand and site you selected and you will not be able to save',
  select_quarter: 'Select Quarter',
  please_select_kpi_quarter: 'Please select KPI Quarter',
  error_fields: 'Error Fields',
  your_answer: 'Your Answer',
  preference: 'Preference',
  return: 'Return',
  please_select_preference_group:
    'You need to select your preferences before submitting!',
  monthly_report: 'Monthly Report',
  draft: 'Draft',
  confirm_send: 'Confirm & Send',
  sent_completion: 'Sent Completion',
  send_draft: 'Send Draft',
  send_draft_monthly_report: 'Send the Monthly Report to your email address.',
  please_confirm_the_recipients:
    'Please confirm the recipients of the Monthly Report',
  total_recipients: 'Total recipients',
  sending: 'Sending',
  sending_monthly_report_tips1: `Your request is currently being processed.`,
  sending_monthly_report_tips2: `Please check the “Action Log” for the result.`,
  configure_upgrade_center: 'Configure Upgrade Center',
  sprint_content: 'Sprint Content',
  release_date: 'Release Date',
  add_sprint: 'Add Sprint',
  sprint_meterials: 'Sprint Materials',
  upgrade_center: 'Upgrade Center',
  function: 'Function',
  my_evaluation_report: 'My Evaluation Report',
  upgrade_center_remove_sprint_number:
    'Are you sure you want to remove this sprint number',
  sprint_version_tips: 'Click to view the sprint materials.',
  edit_sprint: 'Edit Sprint',
  new_sprint_tips: 'Now you can click here to view the sprint materials',
  production_date_range: 'Production Date Range',
  quality: 'Quality',
  preparation: 'Preparation',
  panel: 'Panel',
  session: 'Session',
  product: 'Product',
  attribute: 'Attribute',
  common_menu_samples: 'Samples',
  common_menu_rounds: 'Rounds',
  common_menu_groups: 'Groups',
  common_menu_suspension_list: 'Suspension List',
  common_menu_planning_week_sessions: 'Planning Week Sessions',
  common_menu_zitec_sessions: 'ZITEC Sessions',
  common_menu_brands: 'Brands',
  common_menu_kpi_brands: 'KPI Brands',
  common_menu_packages: 'Packages',
  common_menu_styles: 'Styles',
  common_menu_malt_variety: 'Malt Variety',
  common_menu_intensities: 'Intensities',
  common_menu_categories: 'Categories',
  common_menu_attributes: 'Attributes',
  common_menu_user_management: 'User Management',
  common_menu_role_management: 'Role Management',
  role_management_create: 'Create custom role',
  role_management_current_role_prefix: 'Your current role is',
  role_management_change_role: 'Change Role',
  role_management_create_title: 'Create Custom Role',
  role_management_role_name: 'Role Name',
  role_management_permission_set: 'Permission set to custom with',
  role_management_role_name_placeholder: 'Enter role name',
  role_management_permission_set_placeholder: 'Select a permission set',
  role_management_search: 'Search roles',
  role_management_permission: 'Function',
  role_management_view: 'View',
  role_management_edit: 'Edit',
  role_management_approve: 'Approve',
  role_management_save_changes: 'Save Changes',
  role_management_reset_title: 'Reset to default permissions?',
  role_management_reset_description: "This will reset the role's permissions to the default configuration and remove all manual changes. This action cannot be undone.",
  role_management_reset_success: 'Permissions successfully reset!',
  role_management_reset_success_desc:
    "This role's permissions have been reset to the default configuration.",
  role_management_reset_failed: 'Failed to reset permissions.',
  role_management_reset_failed_desc: 'Please try again in a moment.',
  role_management_switch_role_title: 'Discard changes?',
  role_management_switch_role_description:
    'You have unsaved permission changes. Switching roles will discard them. Do you want to continue?',
  role_management_switch_role_confirm: 'Switch role',
  role_management_delete_title: 'Delete custom role?',
  role_management_delete_preview: '{{role}} will be permanently removed. {{count}} users assigned to this role will be changed to {{defaultRole}}. Are you sure you want to continue?',
  role_management_delete_preview_no_users: '{{role}} will be permanently removed. Are you sure you want to continue?',
  role_management_delete_final: 'This action cannot be undone. Delete this role and clear its assigned users?',
  role_management_load_failed: 'Failed to load roles.',
  role_management_permissions_failed: 'Failed to load permissions.',
  role_management_create_required: 'Enter a role name and select a permission set.',
  role_management_created: 'Custom role successfully created!',
  role_management_created_desc:
    'Check it out in the Permission Control below.',
  common_apply: 'Apply',
  role_management_default_role: 'the default role',
  role_management_create_failed: 'Failed to create role.',
  role_management_create_failed_desc: 'Please try again in a moment.',
  cancel_create_role_title: 'Cancel creating custom role?',
  cancel_create_role_description:
    'You have entered content in the form. Canceling will discard all unsaved input. Are you sure you want to continue?',
  cancel_create_role_confirm: 'Cancel creating role',
  role_management_saved: 'Role changes saved successfully.',
  role_management_save_failed: 'Failed to save role changes.',
  role_management_save_success: 'Role permissions successfully updated!',
  role_management_save_success_desc:
    'The changes have been saved. You can review them in the Permission Control below.',
  role_management_save_failed_desc: 'Please try again in a moment.',
  role_management_deleted: 'Role deleted successfully.',
  role_management_delete_failed: 'Failed to delete role.',
  common_menu_permission_control: 'Permission Control',
  system: 'System',
  select_taste_type: 'Select Taste Type',
  select_round: 'Select round',
  a_previous_request_is_still_being_processed:
    'A previous request is still being processed. Please try again later.',
  select_item: 'Select {{field}}',
  table_apply: 'Apply',
  table_clear: 'Clear',
  table_search: 'Search',
  table_enter_to_filter: 'Enter to filter...',
  table_select_to_filter: 'Select to filter...',
  table_select_all: 'Select all',
  table_select_all_aria: 'Select all rows',
  table_select_row_aria: 'Select row',
  table_filter_by: 'Filter by',
  table_clear_filters: 'Clear filters',
  table_reset_filters: 'Reset filters',
  table_no_results_for_filters: 'No results found for the applied filters.',
  table_items_selected: 'items selected',
  table_sort: 'Sort',
  table_sort_toggle: 'Click to toggle sorting',
  table_no_options: 'No options available',
  table_reset: 'Reset',
  table_all: 'All',
  table_no_results: 'No results found for the applied filters',
  common_approved_at: 'Approved at {{date}}',
  common_rejected_at: 'Rejected at {{date}}',
  kpi_status_created: 'Created',
  kpi_status_waiting_for_approval: 'Waiting for Approval',
  kpi_status_approved: 'Approved',
  kpi_status_rejected: 'Rejected',
  kpi_action_approve: 'Approve',
  kpi_action_reject: 'Reject',
  common_by_user: 'by {{user}}',
  pagination_aria_label_next_page: 'Go to next page',
  pagination_aria_label_previous_page: 'Go to previous page',
  pagination_aria_label_first_page: 'Go to first page',
  pagination_aria_label_last_page: 'Go to last page',
  pagination_aria_label_input:
    'Enter the page you want, from 1 to {totalItems}',
  pagination_aria_label_items_per_page:
    '{pageSize} items per page selected, click to change',
  pagination_lines_per_page: 'Lines per page',
  pagination_total_pages: 'of {totalPages}',
  pagination_total_elements: '{firstItem}-{lastItem} of {totalItems} results',
  pagination_no_results: 'No results found',
  kpi_brand_successfully_saved: 'KPI brand successfully saved!',
  kpi_brand_saved_description:
    'Check it out in the KPI brand below. This is only temporary save, approval submission is not completed yet.',
  kpi_brand_failed_to_save: 'KPI brand failed to save.',
  kpi_brand_save_failed_description: 'Please try again in a moment.',
  kpi_brand_successfully_submitted: 'KPI brand successfully created!',
  kpi_brand_submitted_description:
    'Check it out in the KPI brand below. Please check approval progress on detail page; this KPI brand becomes available only after approval.',
  kpi_brand_failed_to_submit: 'KPI brand failed to create.',
  kpi_brand_submit_failed_description: 'Please try again in a moment.',
  actions: 'Actions',
  actions_page_description:
    'View all Actions created by users during tasting session.',
  action_creator: 'Creator',
  action_created_by: 'Created',
  open_in_interaction_log: 'Open in Interaction Log',
  day: 'day',
  days: 'days',
  days_overdue: 'days overdue',
  my_actions: 'My Actions',
  action_cancel: 'Cancel',
  action_menu_close: 'Close',
  action_add_comment: 'Add Comment',
  action_comment_added: 'Comment added successfully',
  action_comment_add_failed: 'Failed to add comment',
  action_comment_placeholder: 'Enter your comment...',
  action_status_changed_with_comment: 'Status changed with comment',
  required_comment_banner:
    "Since you are not the owner of this action, it's necessary to provide a comment on behalf of the owner.",
  cancel_and_comment: 'Cancel & Comment',
  close_and_comment: 'Close & Comment',
  action_edit_action: 'Edit Action',
  action_list_info: 'Action will be created after the round close.',
  add_taster: 'Add Taster',
  alcohol_concentration_result: 'Alcohol Concentration Result',
  input_concentration: 'Input concentration',
  use_breathalyzer: 'Use breathalyzer',
  enter_concentration: 'Enter Concentration',
  result_refreshing: 'Result refreshing',
  last_update: 'Last update',
  within_standard_range: 'Within the Standard Range',
  excess_alcohol_concentration: 'Excess Alcohol Concentration',
  concentration_standard: 'Concentration Standard',
  breathalyzer_connected_successfully: 'Breathalyzer connected successfully!',
  breathalyzer_blow_to_capture:
    'Please blow to the breathalyzer to capture your reading.',
  breathalyzer_connect_prompt:
    'Click the button below to connect the breathalyzer.',
};
